import "./App.css";
import WeatherApp from "./components/weather_app/WeatherApp";

function App() {
  return (
    <div className="App">
      <WeatherApp />
    </div>
  );
}

export default App;
